import React from 'react';

const RecentActivities = () => {
  // Sample activities data
  const activities = [
    { id: 1, icon: "📋", text: "Lab results received - John Doe" },
    { id: 2, icon: "🔍", text: "Imaging report available - Mary Johnson" },
    { id: 3, icon: "📝", text: "Consult note from Dr. Chen - Sarah Smith" },
  ];

  return (
    <div className="bg-white rounded-lg shadow mb-6">
      <div className="p-4 border-b">
        <h2 className="text-lg font-medium text-gray-800">Recent Patient Activities</h2>
      </div>
      <div className="p-3">
        {activities.map(activity => (
          <div key={activity.id} className="flex items-start p-2 hover:bg-gray-50 rounded cursor-pointer">
            <span className="mr-3">{activity.icon}</span>
            <span className="text-gray-800">{activity.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivities;